export const GENRE_MAP = {
  children: 'children\'s',
  hiphop: 'hip hop',
  rnb: 'r&B',
  spokenandaudio: 'spoken audio',
};

export function mapGenres(genres) {
  return genres.map((genre) => {
    if (GENRE_MAP[genre.name]) {
      return { ...genre, name: GENRE_MAP[genre.name] };
    }

    return genre;
  });
}



// WEBPACK FOOTER //
// ./src/mappers/genres.js